export const passwordTooltipText = `Passwords require: at least 10 characters, a number, a special character, an uppercase letter and a lowercase letter.
     Passwords must not: contain part of the username, first name or last name.`;
